module.exports = __webpack_public_path__ + "img/1695261375223-WhatsApp Image 2023-09-21 at 09.55.14.jpeg.3c9c9532.webp";